import React, {useContext} from 'react'

const Faq: React.FC = () => {
  return (
    <div className="min-h-screen">
      <div className="bg-other flex h-[100vh] w-full justify-center items-center px-5 lg:px-40 md:px-20">
        <h1 className="text-white">FAQ page</h1>
      </div>
    </div>
  );
}

export default Faq;